<!-- src/App.vue -->
<template>
  <div class="min-h-screen flex flex-col">
    <Header />
    <main class="flex-grow">
      <router-view />
      <Toast /> 
    </main>

    <Footer />
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import Header from "./components/layout/Header.vue";
import Footer from "./components/layout/Footer.vue";
import Toast from "./components/layout/Toast.vue";
import { ShopService } from "./api";

/* ---------- helpers ---------- */
const loadScript = ({
  id,
  src,
  innerHTML, 
  async = true,
  type = "text/javascript",
}) => {
  if (id && document.getElementById(id)) return;

  const script = document.createElement("script");
  if (id) script.id = id;
  script.type = type;

  if (src) {
    script.async = async;
    script.src = src;
  }

  if (innerHTML) {
    script.textContent = innerHTML;
  }

  document.head.appendChild(script);
};

/* ---------- inject services ---------- */
const injectTrackers = (data) => {
  /* ✅ Google Tag Manager */
  if (data.tagManager) {
    loadScript({
      id: "gtm-script",
      src: `https://www.googletagmanager.com/gtm.js?id=${data.tagManager}`,
    });

    if (!document.getElementById("gtm-noscript")) {
      const noscript = document.createElement("noscript");
      noscript.id = "gtm-noscript";
      noscript.innerHTML = `
        <iframe src="https://www.googletagmanager.com/ns.html?id=${data.tagManager}"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>
      `;
      document.body?.prepend(noscript); // ✅ optional chaining
    }
  }

  /* ✅ Google Analytics (gtag) */
  if (data.googleAnalytics) {
    loadScript({
      id: "ga-script",
      src: `https://www.googletagmanager.com/gtag/js?id=${data.googleAnalytics}`,
    });

    loadScript({
      id: "ga-config",
      innerHTML: `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${data.googleAnalytics}');
      `,
    });
  }

  /* ✅ Yektanet */
  if (data.yektanet) {
    loadScript({
      id: "yektanet-script",
      innerHTML: `
        !function(t,e,n){
          t.yektanetAnalyticsObject=n;
          t[n]=t[n]||function(){
            t[n].q.push(arguments)
          };
          t[n].q=t[n].q||[];
          var a=e.createElement("script"),
              r=e.getElementsByTagName("script")[0];
          a.async=1;
          a.src="https://cdn.yektanet.com/rg_woebegone/scripts_v2/${data.yektanet}/rg.complete.js";
          r.parentNode.insertBefore(a,r);
        }(window,document,"yektanet");
      `,
    });
  }

  /* ✅ Goftino */
  /* ✅ Goftino (نسخه صحیح با localStorage) */
  if (data.goftino) {
    loadScript({
      id: "goftino-script",
      async: false, // ⬅️ مهم
      type: "text/javascript",
      innerHTML: `
!function(){var i="${data.goftino}",d=document,g=d.createElement("script"),
s="https://www.goftino.com/widget/"+i,
l=localStorage.getItem("goftino_"+i);
g.type="text/javascript",g.async=!0,g.src=l?s+"?o="+l:s;
d.getElementsByTagName("head")[0].appendChild(g);}();
    `.trim(),
    });
  }
};

/* ---------- mount ---------- */
onMounted(async () => {
  try {
    const settings = await ShopService.getStore();
    console.log(settings);
    if (settings.licenses_link) injectTrackers(settings.licenses_link);
  } catch (e) {
    console.error("Tracking inject error:", e);
  }
});
</script>

<style>
@font-face {
  font-family: "BYekan";
  src: url("@/assets/BYekan+.ttf") format("opentype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  font-family: BYekan;
}
</style>
